import Container from '../components/container'
import ContentBlock from '../components/contentBlock'
import Layout from '../containers/layout'
import React from 'react'
import SEO from '../components/seo'

const NotFoundPage = (props) => {
  const { data, errors } = props

  return (
    <Layout>
      <SEO title="404 Not Found" />
      <Container>
        <ContentBlock blockSlug={'404-page'} key="1" />
      </Container>
    </Layout>
  )
}

export default NotFoundPage
